import { render, staticRenderFns } from "./OrderInfoMessages.vue?vue&type=template&id=1578f1d6&scoped=true&"
import script from "./OrderInfoMessages.vue?vue&type=script&lang=js&"
export * from "./OrderInfoMessages.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoMessages.vue?vue&type=style&index=0&id=1578f1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578f1d6",
  null
  
)

export default component.exports